import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ConcurObjectDataset } from 'app/model/dataset/concur.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'ConcurSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(ConcurObjectDataset) }
})
export class ConcurCopySource extends TabularCopySource {
}
